import { useMutation } from '@tanstack/react-query';
import { postEmoji, postGameEmoji } from '~/api';
import { PostEmojiRequest } from '~/types';
import { PostGameEmojiRequestData } from '~/types/missionGameApi';
import useToast from '~/store/useToast';
import useUpdateEmoji from './useUpdateEmoji';

const usePostEmojiMutation = () => {
  const { updateEmojiLike, deleteEmojiLike } = useUpdateEmoji();
  const { showToast } = useToast();
  return useMutation({
    mutationFn: (request: PostEmojiRequest | PostGameEmojiRequestData) =>
      'game_id' in request
        ? postGameEmoji(request as unknown as PostGameEmojiRequestData)
        : postEmoji(request as unknown as PostEmojiRequest),
    onMutate: (request) => {
      updateEmojiLike(request);
    },
    onError: (error, request) => {
      console.error('Failed to post emoji:', error);
      deleteEmojiLike(request);
      showToast('error', 'failed to post emoji');
    },
  });
};

export default usePostEmojiMutation;
